import type { ProductFormValues } from "./types";

/** Обязательное поле формы продукта, без которого кнопки шапки неактивны. */
export type ProductRequiredField =
  | "title"
  | "description"
  | "dates"
  | "preview"
  | "price";

/**
 * Список незаполненных обязательных полей в порядке их следования в форме.
 * Пустой список означает, что продукт можно сохранить и опубликовать.
 * Даты считаются одним полем (нет startAt или finishAt), цена тоже
 * (нет периода или суммы у первой цены).
 */
export function getMissingRequiredFields(
  values: ProductFormValues
): ProductRequiredField[] {
  const firstPrice = values.prices[0];
  const missing: ProductRequiredField[] = [];

  if (!values.title) missing.push("title");
  if (!values.description) missing.push("description");
  if (!values.startAt || !values.finishAt) missing.push("dates");
  if (!values.previewId) missing.push("preview");
  if (!firstPrice?.period || !firstPrice.periods[0]?.value) {
    missing.push("price");
  }

  return missing;
}
